import { Box } from '@material-ui/core';
import { AbsoluteGrid, BodyContainer } from 'containers/LegalNoticePage/styles';
import React from 'react';

interface bodyProps {
  content: React.ReactNode;
  fullscreen?: boolean;
}
const Body = ({ content, fullscreen = false }: bodyProps) => {
  const px = fullscreen ? 0 : [2, 10, 40];
  const py = fullscreen ? 0 : 5;
  return (
    <BodyContainer>
      <AbsoluteGrid>
        <Box py={py} px={px}>
          {content}
        </Box>
      </AbsoluteGrid>
    </BodyContainer>
  );
};
export default Body;
